import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localizedFormat from "dayjs/plugin/localizedFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import _ from "lodash";
import { ref } from "vue";
import { usePage } from "@inertiajs/vue3";
import langData from '../js/lang/en.json';


dayjs.extend(customParseFormat);
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);

export const abortControllers = ref([]);
const pageProps = usePage();


export function timeFormat(time, format = "H:i A") {
    return dayjs(time, "HH:mm:ss").format("LT");
}

export function timeFormatData(timeObject, format = "HH:mm:ss") {
    const { hours, minutes, seconds } = timeObject;
    const timeString = `${hours}:${minutes}:${seconds}`;
    return dayjs(timeString, "HH:mm:ss").format(format);
}

export function dateFormat(
    date,
    from_format = "YYYY-MM-DD",
    to_format = "DD/MM/YYYY"
) {
    if (!date) {
        return "<i>N/A</i>";
    }
    if (locale == "en") {
        to_format = "MM/DD/YYYY";
    }
    return dayjs(date, from_format).format(to_format);
}

export function dateTimeHumanize(dateTime) {
    if (dateTime) {
        return dayjs(dateTime).fromNow();
    }
    return null;
} 

export function isMobile() {
  return window.innerWidth < 1024
}

export function dateTimeFormat(dateTime) {
    let from_format = "YYYY-MM-DD";
    let to_format = "YYYY-MM-DD hh:mm:ss";
    // if (locale == "en") {
    //     to_format = "MM/DD/YYYY hh:mm A";
    // }
    let client_tz = dayjs.tz.guess() ? dayjs.tz.guess() : SERVER_TZ;
    return dayjs.tz(dateTime, client_tz).format(to_format);
}

export function dateTimeFormatServer(dateTime) {
    let to_format = "YYYY-MM-DD";
    let client_tz = dayjs.tz.guess() ? dayjs.tz.guess() : SERVER_TZ;
    return dayjs.tz(dateTime, client_tz).format(to_format);
}

export function monthFormatServer(dateTime) {
    let to_format = "MM-YYYY";
    let client_tz = dayjs.tz.guess() ? dayjs.tz.guess() : SERVER_TZ;
    return dayjs.tz(dateTime, client_tz).format(to_format);
}

function addZeroes(num) {
    num = typeof num == "number" ? num.toString() : num;
    const dec = num.split(".")[1];
    const len = 2;
    return Number(num).toFixed(len);
}

export function getItemCost(basePrice, disType, disValue) {
    let discountAmount = 0;
    discountAmount =
        disType == "percentage" ? basePrice * (disValue / 100) : disValue;
    return addZeroes(basePrice - discountAmount);
}

export function openWindowWithPost(url, data) {
    let dataForm = document.createElement("form");
    dataForm.style.display = "none";
    dataForm.target = "_blank"; //Make sure the window name is same as this value
    dataForm.method = "POST";
    dataForm.action = url;
    for (let key in data) {
        let postData = document.createElement("input");
        postData.type = "hidden";
        postData.name = key;
        postData.value = data[key];
        dataForm.appendChild(postData);
    }
    document.body.appendChild(dataForm);
    dataForm.submit();
}

export const trans = (string, args) => {
    let value = _.get(langData, string);

    let defaultVal = _.last(_.split(string, "."));
    if (value) {
        _.eachRight(args, (paramVal, paramKey) => {
            value = _.replace(value, `:${paramKey}`, paramVal);
        });
    } else {
        value = defaultVal;
    }
    return value;
};

export const convertJsonToFormData = (data, formData = new FormData(), parentKey = '') => {
    if (data === null || data === undefined) {
        return formData;
    }

    // File
    if (data instanceof File) {
        formData.append(parentKey, data);
        return formData;
    }

    // Date
    if (data instanceof Date) {
        formData.append(parentKey, data.toISOString());
        return formData;
    }

    // Array
    if (Array.isArray(data)) {
        data.forEach((value, index) => {
            const key = parentKey ? `${parentKey}[${index}]` : index;
            convertJsonToFormData(value, formData, key);
        });
        return formData;
    }

    // Object
    if (typeof data === 'object') {
        Object.keys(data).forEach((key) => {
            const value = data[key];
            const formKey = parentKey ? `${parentKey}[${key}]` : key;
            convertJsonToFormData(value, formData, formKey);
        });
        return formData;
    }

    // Boolean
    if (typeof data === 'boolean') {
        formData.append(parentKey, data ? 1 : 0);
        return formData;
    }

    // Primitive (string, number)
    formData.append(parentKey, data);
    return formData;
};


export const loadTypeform = async () => {
    // sorry I am not familiar with Vue and don't know how to load external scripts and styles :)
    return new Promise((resolve) => {
        const script = document.createElement("script");
        script.setAttribute("src", "//embed.typeform.com/next/embed.js");
        script.onload = resolve;
        document.head.appendChild(script);

        const cssLink = document.createElement("link");
        cssLink.setAttribute("rel", "stylesheet");
        cssLink.setAttribute(
            "href",
            "//embed.typeform.com/next/css/slider.css"
        );
        document.head.appendChild(cssLink);
    });
};

export const validation = (validation_type, field) => {
    const validation = {
        maxLength: {
            email: "150", //university , college, college contact, employee document page candidate page , employee page, employee work experience page
            name: "255", //university , institute, candidate page , hosting page,employee page, employee immigration page, employee contact page, employee document page, employeee qualification page
            // employee contract page, role&previleges page, holiday page
            constant_name_1: "50", //used in  qualification language page,document type page,ethinicity type page,income type page,travel arrrangement type page  currency type page,
            //company type page,securtiy type page , programming language,hosting plan ,reason ,loan option page, college contact page, interview mode ,insterviw source, job category
            // stream page contract type page, interview source category, job category, qualification education level page, qualification skill,employee page,employee contact page,leave type ,
            // employee exit type page

            constant_name_2: "100", // used in  award type page, warning type page, termination type page,
            currency_code: "3", // used in currency type page
            currency_symbol: "3", // used in currency type page
            strength: "10", //used in college page
            remarks: "3000", // used in follow ups page,employee security level page
            short_description: "2500", // used in job page
            additional_comments: "3000", // used in requisition page,
            url: "2048", /// use employee social account page,
            bank_branch: "500", // use employee bank account
        },
        minLength: {
            email: "2",
            name: "3",
        },

        maxNumber: {
            max_no_1: 100000000000, // used in candidate page, requisition page
            max_no_2: 1000, // used in candidate page,server page
            reminder_days: 365, // used in hosting page
            quantity: 100000, //used in asset page
            minimum_experience: 100, //use in job page,
            openings: 10000, // use in job page
        },
    };
    return validation[validation_type][field];
};

export const formatCustomDate = (date, formatStr) => {
    const formatMap = {
        Y: () => date.getFullYear(),
        y: () => String(date.getFullYear()).slice(-2),
        m: () => String(date.getMonth() + 1).padStart(2, "0"),
        mm: () => String(date.getMonth() + 1),
        d: () => String(date.getDate()).padStart(2, "0"),
        j: () => date.getDate(),
        n: () => date.getMonth() + 1,
        D: () =>
            new Intl.DateTimeFormat("en-US", { weekday: "short" }).format(date),
        l: () =>
            new Intl.DateTimeFormat("en-US", { weekday: "long" }).format(date),
        M: () =>
            new Intl.DateTimeFormat("en-US", { month: "short" }).format(date),
        F: () =>
            new Intl.DateTimeFormat("en-US", { month: "long" }).format(date),
        S: () => getDaySuffix(date.getDate()),
        A: () => (date.getHours() >= 12 ? "PM" : "AM"),
        H: () => String(date.getHours()).padStart(2, "0"),
        h: () => String(date.getHours() % 12 || 12).padStart(2, "0"),
        i: () => String(date.getMinutes()).padStart(2, "0"),
        s: () => String(date.getSeconds()).padStart(2, "0"),
        U: () => Math.floor(date.getTime() / 1000),
    };
    return formatStr.replace(
        /Y|y|mm|m|d|j|n|D|l|M|F|S|A|H|h|i|s|U/g,
        (match) => {
            return formatMap[match] ? formatMap[match]() : match;
        }
    );
};

export const getDaySuffix = (day) => {
    const suffixes = ["th", "st", "nd", "rd"];
    const value = day % 100;
    return suffixes[(value - 20) % 10] || suffixes[value] || suffixes[0];
};

import { useAppStore } from "./store";
export const validateFormDates = (startDate, endDate, type) => {
    if (startDate == null || endDate == null) {
        return false;
    }
    const from_date = new Date(startDate);
    const to_date = new Date(endDate);
    const appStore = useAppStore();
    if (to_date.getTime() < from_date.getTime()) {
        let notification = {
            heading: trans("lang.labels.date_error"),
            subHeading: `Please Select end date after the start date (${startDate})`,
            type: type,
        };
        appStore.setNotification(notification);
        return true;
    }
    return false;
};

export const titleCase = (string) => {
    return string
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
};

export const cancelAllRequests = () => {
    abortControllers.value.forEach((controller) => controller.abort());
    abortControllers.value = [];
};

export const getCookie = (name) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i].trim();
        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
    return null;
};
const attendance_status_colors = window?.APP?.attendance_status_colors;

export const attendanceLabels = [
    {
        label: "P",
        description: "Present",
        class: "eventPresent",
        bgColor: attendance_status_colors?.present,
        extra: true
    },
    {
        label: "A",
        description: "Absent",
        class: "eventAbsent",
        bgColor: attendance_status_colors?.absent,
        extra: true
    },
    {
        label: "I",
        description: "In Active",
        class: "eventInactive",
        bgColor: attendance_status_colors?.inactive,
    },
    {
        label: "S",
        description: "Separated",
        class: "eventSeparated",
        bgColor: attendance_status_colors?.separated,
    },
    {
        label: "H",
        description: "Holiday",
        class: "eventHoliday",
        bgColor: attendance_status_colors?.holiday,
        sandwichCheck: true,
    },
    {
        label: "H(S)",
        description: "Holiday Sandwich",
        class: "eventSandwiched",
        bgColor: attendance_status_colors?.sandwich,
    },
    {
        label: "L",
        description: "On Leave",
        class: "eventLeave",
        bgColor: attendance_status_colors?.on_leave,
    },
    {
        label: "HD",
        description: "Half Day",
        class: "eventHalfLeave",
        extra: true,
        bgColor: attendance_status_colors?.half_day,
    },
    {
        label: "FH(A)",
        description: "First Half Absent",
        class: "eventHalfLeave",
        extra: true,
        bgColor: attendance_status_colors?.first_half_absent,
    },
    {
        label: "FH(L)",
        description: "First Half Leave",
        class: "eventHalfLeave",
        extra: true,
        bgColor: attendance_status_colors?.first_half,
    },
    {
        label: "SH(A)",
        description: "Second Half Absent",
        class: "eventHalfLeave",
        extra: true,
        bgColor: attendance_status_colors?.second_half_absent,
    },
    {
        label: "SH(L)",
        description: "Second Half Leave",
        class: "eventHalfLeave",
        extra: true,
        bgColor: attendance_status_colors?.second_half,
    },
    {
        label: "NSA",
        description: "No Shift Assigned",
        class: "eventNoShiftAssigned",
        bgColor: attendance_status_colors?.no_shift_assigned,
    },
    {
        label: "LD",
        description: "Leaving Date",
        class: "eventLeavingDate",
        bgColor: attendance_status_colors?.leaving_date,
    },
    {
        label: "JD",
        description: "Joining Date",
        class: "eventJoiningDate",
        bgColor: attendance_status_colors?.leaving_date,
    },
    {
        label: "P(H)",
        description: "Present On Holiday",
        class: "eventPresentOnHoliday",
        bgColor: attendance_status_colors?.present_on_holiday,
        extra: true
    },
];
export const loanStatusConfig = [
    {
        label: "Applied",
        key: "applied",
        description: trans("lang.labels.applied_loan"),
        class: "statusApplied",
        bgColor: '#067dd6',
    },
    {
        label: "Processed",
        key: "processed",
        description: trans("lang.labels.processed_loan"),
        class: "statusProcessed",
        bgColor: '#f59e0b',
    },
    {
        label: "Active",
        key: "active",
        description: trans("lang.labels.active_loan"),
        class: "statusActive",
        bgColor: '#10b981',
    },
    {
        label: "Rejected",
        key: "rejected",
        description: trans("lang.labels.rejected_loan"),
        class: "statusRejected",
        bgColor: '#ef4444',
    },
    {
        label: "Pending",
        key: "pending",
        description: trans("lang.labels.pending_loan"),
        class: "statusPending",
        bgColor: '#f59e0b',
    },
    {
        label: "Paid",
        key: "paid",
        description: trans("lang.labels.paid_loan"),
        class: "statusPaid",
        bgColor: '#10b981',
    },
    {
        label: "Approved",
        key: "approved",
        description: trans("lang.labels.approved_loan"),
        class: "statusApproved",
        bgColor: '#10b981',
    },
    {
        label: "Cancelled",
        key: "cancelled",
        description: trans("lang.labels.cancelled_loan"),
        class: "statusCancelled",
        bgColor: '#ef4444',
    },
    {
        label: "Draft",
        key: "draft",
        description: trans("lang.labels.draft_loan"),
        class: "statusDraft",
        bgColor: '#6b7280',
    },
    {
        label: "Responded",
        key: "responded",
        description: trans("lang.labels.responded_loan"),
        class: "statusResponded",
        bgColor: '#38ff95',
    },
];

export const formatAmount = (amount, symbol = null, position = "prefix") => {
    if (!symbol) {
        const defaultCurrency = window?.APP?.default_currency_symbol || {};
        symbol = defaultCurrency.symbol || "";
        position = defaultCurrency.position || "prefix";
    }

    const numericAmount = Number(amount) || 0;

    const formattedAmount = numericAmount.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    if (position === "prefix") {
        return `${symbol} ${formattedAmount}`;
    } else {
        return `${formattedAmount} ${symbol}`;
    }
};

export const formatTime = (time, format) => {
    if (!time) return "--";
    let { hours, minutes, seconds } = time;

    hours = String(hours).padStart(2, "0");
    minutes = String(minutes).padStart(2, "0");
    seconds = String(seconds).padStart(2, "0");

    switch (format) {
        case "H:i":
            return `${hours}:${minutes}`;
        case "H":
            return `${hours}`;
        default:
            return `${hours}:${minutes}:${seconds}`;
    }
};

export const captureLocation = async (config) => {
    const appStore = useAppStore();
    if (appStore.geoLocation.latitude && appStore.geoLocation.longitude) {
        config.headers["X-Geo-Latitude"] = appStore.geoLocation.latitude;
        config.headers["X-Geo-Longitude"] = appStore.geoLocation.longitude;
        return config;
    }
    if (navigator.geolocation) {
        try {
            const position = await new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(resolve, reject, {
                    timeout: 5000,
                });
            });
            config.headers["X-Geo-Latitude"] = position.coords.latitude;
            config.headers["X-Geo-Longitude"] = position.coords.longitude;
            appStore.geoLocation.latitude = position.coords.latitude;
            appStore.geoLocation.longitude = position.coords.longitude;
        } catch (error) {
            console.warn(`Geolocation error: ${error.message}`);
        }
    }
    return config;
};

export function getFormattedDateTime() {
    const now = new Date();

    const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];

    const month = monthNames[now.getMonth()];
    const day = now.getDate();
    const year = now.getFullYear();

    let hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12;
    hours = hours || 12; // 0 → 12

    const pad = (n) => n.toString().padStart(2, "0");

    return `${month} ${day}, ${year} - ${pad(hours)}:${pad(minutes)}:${pad(
        seconds
    )} ${ampm}`;
}

export function buildDescription(log) {
    // If properties is not an array, fallback to old logic
    if (!Array.isArray(log.properties)) {
        const { attributes = {}, old = {} } = log.properties || {};
        const changes = Object.keys(attributes)
            .map((key) => {
                const oldVal = old[key] ?? "N/A";
                const newVal = attributes[key];
                if (oldVal == newVal) {
                    return "";
                } else if ((!oldVal || oldVal == "N/A") && newVal) {
                    return `<li>${key} set to <span class="font-bold hrmTitleSecondaryColor">"${newVal}"</span></li>`;
                } else if (oldVal && newVal) {
                    return `<li>${key} changed from <span class="font-bold hrmTitleSecondaryColor">"${oldVal}"</span> to <span class="font-bold hrmTitleSecondaryColor">"${newVal}"</span></li>`;
                } else {
                    return "";
                }
            })
            .filter((change) => change !== "");
        return changes.length
            ? `<ul class="hrmClientActivityList" style="padding-left: 1.2em; list-style-type: disc;">${changes.join(
                ""
            )}</ul>`
            : "No changes recorded";
    }

    // If properties is an array
    const changes = log.properties
        .map((prop) => {
            const key = prop.key || "unknown";
            const oldVal = prop.old ?? "N/A";
            const newVal = prop.new ?? "N/A";
            if (oldVal == newVal) {
                return "";
            } else if (
                (!oldVal || oldVal == "N/A") &&
                newVal &&
                newVal != "N/A"
            ) {
                return `<li>${key} set to <span class="font-bold hrmTitleSecondaryColor">"${newVal}"</span></li>`;
            } else if (oldVal && oldVal != "N/A" && newVal && newVal != "N/A") {
                return `<li>${key} changed from <span class="font-bold hrmTitleSecondaryColor">"${oldVal}"</span> to <span class="font-bold hrmTitleSecondaryColor">"${newVal}"</span></li>`;
            } else {
                return "";
            }
        })
        .filter((change) => change !== "");

    return changes.length
        ? `<ul class="hrmClientActivityList" style="padding-left: 1.2em; list-style-type: disc;">${changes.join(
            ""
        )}</ul>`
        : "No changes recorded";
}

export function utcDateTime() {
    const now = new Date();

    return (
        now.getUTCFullYear() +
        "-" +
        String(now.getUTCMonth() + 1).padStart(2, "0") +
        "-" +
        String(now.getUTCDate()).padStart(2, "0") +
        " " +
        String(now.getUTCHours()).padStart(2, "0") +
        ":" +
        String(now.getUTCMinutes()).padStart(2, "0") +
        ":" +
        String(now.getUTCSeconds()).padStart(2, "0")
    );
}
export function copyText(textToCopy) {
    if (!navigator.clipboard) {
        const textarea = document.createElement("textarea");
        textarea.value = textToCopy;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
    } else {
        navigator.clipboard
            .writeText(textToCopy)
            .then(() => {
                console.log("Text copied to clipboard");
            })
            .catch((error) => {
                console.error("Failed to copy text: ", error);
            });
    }
}
export function getStatusBadgeClass(status, type = 'default') {
    if (!status) return '';

    const normalizedStatus = status
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();

    const withBg = {
        'in process': 'bg-yellow-200 text-yellow-700',
        'hired': 'bg-green-100 text-green-700',
        'tie up': 'bg-indigo-100 text-indigo-700',
        'blocked': 'bg-red-100 text-red-700',
        'cancelled': 'bg-gray-200 text-gray-700',
        'rejected': 'bg-red-200 text-red-800',
        'on hold': 'bg-yellow-200 text-yellow-800',
    };

    const withoutBg = {
        'in process': 'text-yellow-400',
        'hired': 'text-green-700',
        'tie up': 'text-indigo-700',
        'blocked': 'text-red-700',
        'cancelled': 'text-gray-700',
        'rejected': 'text-red-800',
        'on hold': 'text-blue-800',
    };

    const classMap = type === 'follow_up' ? withoutBg : withBg;

    return classMap[normalizedStatus] || (
        type === 'follow_up'
            ? 'bg-gray-100 text-gray-600'
            : 'text-orange-600'
    );
}

export const deleteFormVariables = (formData, formVariables = []) => {
    if (
        !formData ||
        typeof formData !== "object" ||
        !Array.isArray(formVariables)
    ) {
        return formData;
    }

    const deepDelete = (obj) => {
        if (!obj || typeof obj !== "object") return;

        Object.keys(obj).forEach((key) => {
            // delete if key matches
            if (formVariables.includes(key)) {
                delete obj[key];
                return;
            }

            // go deeper (objects / arrays)
            const value = obj[key];
            if (typeof value === "object" && value !== null) {
                deepDelete(value);
            }
        });
    };

    deepDelete(formData);
    return formData;
};


export const checkActiveModule = (moduleAlias) => {
    const activeModules = pageProps?.props?.activeModules || [];

    if (!Array.isArray(activeModules)) return false;

    // Normalize to array
    const aliases = Array.isArray(moduleAlias)
        ? moduleAlias
        : [moduleAlias];

    return aliases.some(alias =>
        activeModules.some(module =>
            module?.toLowerCase() === alias?.toLowerCase()
        )
    );
};